/**
 * Remueve todas las clases que matcheen con el regex dado
 * @param regex
 * @returns {*|jQuery}
 */
$.fn.removeClassRegex = function(regex) {
	return $(this).removeClass(function(index, classes) {
		return classes.split(/\s+/).filter(function(c) {
			return regex.test(c);
		}).join(' ');
	});
};

/**
 * KeyUp with delay event setup
 *
 * @link http://stackoverflow.com/questions/1909441/jquery-keyup-delay#answer-12581187
 * @param function callback
 * @param int ms
 */
$.fn.delayKeyup = function(callback, ms = 200){
	$(this).keyup(function( event ){
		var srcEl = event.currentTarget;
		if( srcEl.delayTimer )
			clearTimeout (srcEl.delayTimer );
		srcEl.delayTimer = setTimeout(function(){ callback( event ); }, ms);
	});

	return $(this);
};

/**
 * Remueve todas las clases que comiencen con el prefijo dado
 * @param prefix
 */
$.fn.removeClassPrefix = function(prefix){
	var c, regex = new RegExp("(^|\\s)" + prefix + "\\S+", 'g');
	// !!!! each deprecated
	return this.each(function(){
		c = this.getAttribute('class');
		if(c.length) this.setAttribute('class', c.replace(regex, ''));
	});
};